<h3 mat-dialog-title>{{ data.title }}</h3>
@if (data.message.length > 0) {
  <mat-dialog-content>
    <p [innerHTML]="data.message + '<br>' + data.subMessage"></p>
  </mat-dialog-content>
}
<mat-dialog-actions class="justify-content-center">
  <div
    class="d-flex flex-column gap-4 gap-sm-2 align-items-center justify-content-evenly"
    [class.flex-sm-row]="!data.revertButtons"
    [class.flex-sm-row-reverse]="data.revertButtons">
    <wfs-form-button
      (buttonClicked)="triggerEvent(1)"
      [label]="data.firstText"
      [buttonStyle]="data.buttonStyles['first']" />
    <wfs-form-button
      (buttonClicked)="triggerEvent(2)"
      [label]="data.secondText"
      [buttonStyle]="data.buttonStyles['second']" />
    <wfs-form-button
      (buttonClicked)="triggerEvent(3)"
      [label]="data.thirdText"
      [buttonStyle]="data.buttonStyles['third']" />
  </div>
</mat-dialog-actions>
